import Vue from "vue";
import VueRouter from "vue-router";
import WineEngine from "./views/wineengine/WineEngine.vue";
import MatchEngine from "./views/matchengine/MatchEngine.vue";
import MobileEngine from "./views/mobileengine/MobileEngine.vue";
import MulticolorEngine from "./views/multicolorengine/MulticolorEngine.vue";
import ProductMenu from "./views/ProductMenu.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: "",
      name: "product_menu",
      component: ProductMenu,
    },
    {
      path: "/wineengine",
      component: WineEngine,
      children: [
        {
          path: "",
          // component: () => import('./views/wineengine/GettingStarted.vue')
          redirect: { name: "wineengine/what_is_wineengine" },
        },
        {
          path: "getting_started",
          name: "wineengine/getting_started",
          component: () => import("./views/wineengine/GettingStarted.vue"),
          meta: {
            title: "Getting started - WineEngine - TinEye developer documentation",
          },
        },
        {
          path: "release_notes",
          name: "wineengine/release_notes",
          component: () => import("./views/wineengine/ReleaseNotes.vue"),
          meta: {
            title: "Release notes - WineEngine - TinEye developer documentation",
          },
        },
        {
          path: "working_with_images",
          name: "wineengine/working_with_images",
          component: () => import("./views/wineengine/WorkingWithImages.vue"),
          meta: {
            title: "Working with images - WineEngine - TinEye developer documentation",
          },
        },
        {
          path: "security_and_privacy",
          name: "wineengine/security_and_privacy",
          component: () => import("./views/matchengine/SecurityAndPrivacy.vue"),
          meta: {
            title: "Security and privacy - WineEngine - TinEye developer documentation",
          },
        },
        {
          path: "user_experience",
          name: "wineengine/user_experience",
          component: () => import("./views/wineengine/UserExperience.vue"),
          meta: {
            title: "User experience - WineEngine - TinEye developer documentation",
          },
        },
        {
          path: "faqs",
          name: "wineengine/faqs",
          component: () => import("./views/wineengine/FAQs.vue"),
          meta: { title: "FAQs - WineEngine - TinEye developer documentation" },
        },
        {
          path: "what_is_wineengine",
          name: "wineengine/what_is_wineengine",
          component: () => import("./views/wineengine/WhatIsWineEngine.vue"),
          meta: {
            title: "What is WineEngine? - WineEngine - TinEye developer documentation",
          },
        },
        {
          path: "api_reference",
          component: () => import("./views/wineengine/ApiRef.vue"),
          children: [
            {
              path: "",
              name: "wineengine/api_reference",
              component: () => import("./views/wineengine/api_reference/ApiRefRequestResponse.vue"),
              meta: {
                title: "API reference - WineEngine - TinEye developer documentation",
              },
            },
            {
              path: "add",
              name: "wineengine/add",
              component: () => import("./views/wineengine/api_reference/methods/ApiRefAdd.vue"),
              meta: {
                title: "POST add - WineEngine - TinEye developer documentation",
              },
            },
            {
              path: "count",
              name: "wineengine/count",
              component: () => import("./views/wineengine/api_reference/methods/ApiRefCount.vue"),
              meta: {
                title: "GET count - WineEngine - TinEye developer documentation",
              },
            },
            {
              path: "delete",
              name: "wineengine/delete",
              component: () => import("./views/wineengine/api_reference/methods/ApiRefDelete.vue"),
              meta: {
                title: "GET delete - WineEngine - TinEye developer documentation",
              },
            },
            {
              path: "extract_label_metadata",
              name: "wineengine/extract_label_metadata",
              component: () =>
                import("./views/wineengine/api_reference/methods/ApiRefExtractLabelMetadata.vue"),
              meta: {
                title: "POST extract_label_metadata - WineEngine - TinEye developer documentation",
              },
            },
            {
              path: "get_label_metadata",
              name: "wineengine/get_label_metadata",
              component: () =>
                import("./views/wineengine/api_reference/methods/ApiRefGetLabelMetadata.vue"),
              meta: {
                title: "GET get_label_metadata - WineEngine - TinEye developer documentation",
              },
            },
            {
              path: "list",
              name: "wineengine/list",
              component: () => import("./views/wineengine/api_reference/methods/ApiRefList.vue"),
              meta: {
                title: "GET list - WineEngine - TinEye developer documentation",
              },
            },
            {
              path: "ping",
              name: "wineengine/ping",
              component: () => import("./views/wineengine/api_reference/methods/ApiRefPing.vue"),
              meta: {
                title: "GET ping - WineEngine - TinEye developer documentation",
              },
            },
            {
              path: "search",
              name: "wineengine/search",
              component: () => import("./views/wineengine/api_reference/methods/ApiRefSearch.vue"),
              meta: {
                title: "POST search - WineEngine - TinEye developer documentation",
              },
            },
          ],
        },
        {
          path: "*",
          redirect: { name: "wineengine/what_is_wineengine" },
        },
      ],
    },
    {
      path: "/matchengine",
      component: MatchEngine,
      children: [
        {
          path: "",
          // component: () => import('./views/matchengine/GettingStarted.vue')
          redirect: { name: "matchengine/what_is_matchengine" },
        },
        {
          path: "getting_started",
          name: "matchengine/getting_started",
          component: () => import("./views/matchengine/GettingStarted.vue"),
          meta: {
            title: "Getting started - MatchEngine - TinEye developer documentation",
          },
        },
        {
          path: "release_notes",
          name: "matchengine/release_notes",
          component: () => import("./views/matchengine/ReleaseNotes.vue"),
          meta: {
            title: "Release notes - MatchEngine - TinEye developer documentation",
          },
        },
        {
          path: "working_with_images",
          name: "matchengine/working_with_images",
          component: () => import("./views/matchengine/WorkingWithImages.vue"),
          meta: {
            title: "Working with images - MatchEngine - TinEye developer documentation",
          },
        },
        {
          path: "security_and_privacy",
          name: "matchengine/security_and_privacy",
          component: () => import("./views/matchengine/SecurityAndPrivacy.vue"),
          meta: {
            title: "Security and privacy - MatchEngine - TinEye developer documentation",
          },
        },
        {
          path: "faqs",
          name: "matchengine/faqs",
          component: () => import("./views/matchengine/FAQs.vue"),
          meta: {
            title: "FAQs - MatchEngine - TinEye developer documentation",
          },
        },
        {
          path: "what_is_matchengine",
          name: "matchengine/what_is_matchengine",
          component: () => import("./views/matchengine/WhatIsMatchEngine.vue"),
          meta: {
            title: "What is MatchEngine? - MatchEngine - TinEye developer documentation",
          },
        },
        {
          path: "api_reference",
          component: () => import("./views/matchengine/ApiRef.vue"),
          children: [
            {
              path: "",
              name: "matchengine/api_reference",
              component: () =>
                import("./views/matchengine/api_reference/ApiRefRequestResponse.vue"),
              meta: {
                title: "API reference - MatchEngine - TinEye developer documentation",
              },
            },
            // {
            //   path: 'request',
            //   name: 'matchengine/request',
            //   component: () => import('./views/matchengine/api_reference/ApiRefRequest.vue'),
            // },
            // {
            //   path: 'response',
            //   name: 'matchengine/response',
            //   component: () => import('./views/matchengine/api_reference/ApiRefResponse.vue'),
            // },
            {
              path: "add",
              name: "matchengine/add",
              component: () => import("./views/matchengine/api_reference/methods/ApiRefAdd.vue"),
              meta: {
                title: "POST add - MatchEngine - TinEye developer documentation",
              },
            },
            {
              path: "count",
              name: "matchengine/count",
              component: () => import("./views/matchengine/api_reference/methods/ApiRefCount.vue"),
              meta: {
                title: "GET count - MatchEngine - TinEye developer documentation",
              },
            },
            {
              path: "delete",
              name: "matchengine/delete",
              component: () => import("./views/matchengine/api_reference/methods/ApiRefDelete.vue"),
              meta: {
                title: "GET delete - MatchEngine - TinEye developer documentation",
              },
            },
            {
              path: "list",
              name: "matchengine/list",
              component: () => import("./views/matchengine/api_reference/methods/ApiRefList.vue"),
              meta: {
                title: "GET list - MatchEngine - TinEye developer documentation",
              },
            },
            {
              path: "ping",
              name: "matchengine/ping",
              component: () => import("./views/matchengine/api_reference/methods/ApiRefPing.vue"),
              meta: {
                title: "GET ping - MatchEngine - TinEye developer documentation",
              },
            },
            {
              path: "search",
              name: "matchengine/search",
              component: () => import("./views/matchengine/api_reference/methods/ApiRefSearch.vue"),
              meta: {
                title: "POST search - MatchEngine - TinEye developer documentation",
              },
            },
            {
              path: "compare",
              name: "matchengine/compare",
              component: () =>
                import("./views/matchengine/api_reference/methods/ApiRefCompare.vue"),
              meta: {
                title: "POST compare - MatchEngine - TinEye developer documentation",
              },
            },
          ],
        },
        {
          path: "*",
          redirect: { name: "matchengine/what_is_matchengine" },
        },
      ],
    },
    {
      path: "/mobileengine",
      component: MobileEngine,
      children: [
        {
          path: "",
          // component: () => import('./views/mobileengine/GettingStarted.vue')
          redirect: { name: "mobileengine/what_is_mobileengine" },
        },
        {
          path: "getting_started",
          name: "mobileengine/getting_started",
          component: () => import("./views/mobileengine/GettingStarted.vue"),
          meta: {
            title: "Getting started - MobileEngine - TinEye developer documentation",
          },
        },
        {
          path: "release_notes",
          name: "mobileengine/release_notes",
          component: () => import("./views/mobileengine/ReleaseNotes.vue"),
          meta: {
            title: "Release notes - MobileEngine - TinEye developer documentation",
          },
        },
        {
          path: "working_with_images",
          name: "mobileengine/working_with_images",
          component: () => import("./views/mobileengine/WorkingWithImages.vue"),
          meta: {
            title: "Working with images - MobileEngine - TinEye developer documentation",
          },
        },
        {
          path: "security_and_privacy",
          name: "mobileengine/security_and_privacy",
          component: () => import("./views/matchengine/SecurityAndPrivacy.vue"),
          meta: {
            title: "Security and privacy - MobileEngine - TinEye developer documentation",
          },
        },
        {
          path: "faqs",
          name: "mobileengine/faqs",
          component: () => import("./views/mobileengine/FAQs.vue"),
          meta: {
            title: "FAQs - MobileEngine - TinEye developer documentation",
          },
        },
        {
          path: "what_is_mobileengine",
          name: "mobileengine/what_is_mobileengine",
          component: () => import("./views/mobileengine/WhatIsMobileEngine.vue"),
          meta: {
            title: "What is MobileEngine? - MobileEngine - TinEye developer documentation",
          },
        },
        {
          path: "api_reference",
          component: () => import("./views/mobileengine/ApiRef.vue"),
          children: [
            {
              path: "",
              name: "mobileengine/api_reference",
              component: () =>
                import("./views/mobileengine/api_reference/ApiRefRequestResponse.vue"),
              meta: {
                title: "API reference - MobileEngine - TinEye developer documentation",
              },
            },
            // {
            //   path: 'request',
            //   name: 'mobileengine/request',
            //   component: () => import('./views/mobileengine/api_reference/ApiRefRequest.vue'),
            // },
            // {
            //   path: 'response',
            //   name: 'mobileengine/response',
            //   component: () => import('./views/mobileengine/api_reference/ApiRefResponse.vue'),
            // },
            {
              path: "add",
              name: "mobileengine/add",
              component: () => import("./views/mobileengine/api_reference/methods/ApiRefAdd.vue"),
              meta: {
                title: "POST add - MobileEngine - TinEye developer documentation",
              },
            },
            {
              path: "count",
              name: "mobileengine/count",
              component: () => import("./views/mobileengine/api_reference/methods/ApiRefCount.vue"),
              meta: {
                title: "GET count - MobileEngine - TinEye developer documentation",
              },
            },
            {
              path: "delete",
              name: "mobileengine/delete",
              component: () =>
                import("./views/mobileengine/api_reference/methods/ApiRefDelete.vue"),
              meta: {
                title: "GET delete - MobileEngine - TinEye developer documentation",
              },
            },
            {
              path: "list",
              name: "mobileengine/list",
              component: () => import("./views/mobileengine/api_reference/methods/ApiRefList.vue"),
              meta: {
                title: "GET list - MobileEngine - TinEye developer documentation",
              },
            },
            {
              path: "ping",
              name: "mobileengine/ping",
              component: () => import("./views/mobileengine/api_reference/methods/ApiRefPing.vue"),
              meta: {
                title: "GET ping - MobileEngine - TinEye developer documentation",
              },
            },
            {
              path: "search",
              name: "mobileengine/search",
              component: () =>
                import("./views/mobileengine/api_reference/methods/ApiRefSearch.vue"),
              meta: {
                title: "POST search - MobileEngine - TinEye developer documentation",
              },
            },
            {
              path: "compare",
              name: "mobileengine/compare",
              component: () =>
                import("./views/mobileengine/api_reference/methods/ApiRefCompare.vue"),
              meta: {
                title: "POST compare - MobileEngine - TinEye developer documentation",
              },
            },
          ],
        },
        {
          path: "*",
          redirect: { name: "mobileengine/what_is_mobileengine" },
        },
      ],
    },
    {
      path: "/multicolorengine",
      component: MulticolorEngine,
      children: [
        {
          path: "",
          // component: () => import('./views/multicolorengine/GettingStarted.vue')
          redirect: { name: "multicolorengine/what_is_multicolorengine" },
        },
        {
          path: "getting_started",
          name: "multicolorengine/getting_started",
          component: () => import("./views/multicolorengine/GettingStarted.vue"),
          meta: {
            title: "Getting started - MulticolorEngine - TinEye developer documentation",
          },
        },
        {
          path: "release_notes",
          name: "multicolorengine/release_notes",
          component: () => import("./views/multicolorengine/ReleaseNotes.vue"),
          meta: {
            title: "Release notes - MulticolorEngine - TinEye developer documentation",
          },
        },
        {
          path: "working_with_images",
          name: "multicolorengine/working_with_images",
          component: () => import("./views/multicolorengine/WorkingWithImages.vue"),
          meta: {
            title: "Working with images - MulticolorEngine - TinEye developer documentation",
          },
        },
        {
          path: "security_and_privacy",
          name: "multicolorengine/security_and_privacy",
          component: () => import("./views/matchengine/SecurityAndPrivacy.vue"),
          meta: {
            title: "Security and privacy - MulticolorEngine - TinEye developer documentation",
          },
        },
        {
          path: "color_classes",
          name: "multicolorengine/color_classes",
          component: () => import("./views/multicolorengine/ColorClasses.vue"),
          meta: {
            title: "Color classes - MulticolorEngine - TinEye developer documentation",
          },
        },
        {
          path: "working_with_metadata",
          name: "multicolorengine/working_with_metadata",
          component: () => import("./views/multicolorengine/WorkingWithMetadata.vue"),
          meta: {
            title: "Working with metadata - MulticolorEngine - TinEye developer documentation",
          },
        },
        {
          path: "faqs",
          name: "multicolorengine/faqs",
          component: () => import("./views/multicolorengine/FAQs.vue"),
          meta: {
            title: "FAQs - MulticolorEngine - TinEye developer documentation",
          },
        },
        {
          path: "what_is_multicolorengine",
          name: "multicolorengine/what_is_multicolorengine",
          component: () => import("./views/multicolorengine/WhatIsMulticolorEngine.vue"),
          meta: {
            title: "What is MulticolorEngine? - MulticolorEngine - TinEye developer documentation",
          },
        },
        {
          path: "api_reference",
          component: () => import("./views/multicolorengine/ApiRef.vue"),
          children: [
            // {
            //   path: 'request',
            //   name: 'multicolorengine/request',
            //   component: () => import('./views/multicolorengine/api_reference/ApiRefRequest.vue'),
            // },
            // {
            //   path: 'response',
            //   name: 'multicolorengine/response',
            //   component: () => import('./views/multicolorengine/api_reference/ApiRefResponse.vue'),
            // },
            {
              path: "",
              name: "multicolorengine/api_reference",
              component: () =>
                import("./views/multicolorengine/api_reference/ApiRefRequestResponse.vue"),
              meta: {
                title: "API reference - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "add",
              name: "multicolorengine/add",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefAdd.vue"),
              meta: {
                title: "POST add - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "count",
              name: "multicolorengine/count",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefCount.vue"),
              meta: {
                title: "GET count - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "delete",
              name: "multicolorengine/delete",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefDelete.vue"),
              meta: {
                title: "GET delete - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "list",
              name: "multicolorengine/list",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefList.vue"),
              meta: {
                title: "GET list - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "ping",
              name: "multicolorengine/ping",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefPing.vue"),
              meta: {
                title: "GET ping - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "color_search",
              name: "multicolorengine/color_search",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefColorSearch.vue"),
              meta: {
                title: "POST color_search - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "count_collection_colors",
              name: "multicolorengine/count_collection_colors",
              component: () =>
                import(
                  "./views/multicolorengine/api_reference/methods/ApiRefCountCollectionColors.vue"
                ),
              meta: {
                title:
                  "GET count_collection_colors - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "extract_collection_colors",
              name: "multicolorengine/extract_collection_colors",
              component: () =>
                import(
                  "./views/multicolorengine/api_reference/methods/ApiRefExtractCollectionColors.vue"
                ),
              meta: {
                title:
                  "GET extract_collection_colors - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "count_image_colors",
              name: "multicolorengine/count_image_colors",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefCountImageColors.vue"),
              meta: {
                title:
                  "POST count_image_colors - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "extract_image_colors",
              name: "multicolorengine/extract_image_colors",
              component: () =>
                import(
                  "./views/multicolorengine/api_reference/methods/ApiRefExtractImageColors.vue"
                ),
              meta: {
                title:
                  "POST extract_image_colors - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "count_metadata",
              name: "multicolorengine/count_metadata",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefCountMetadata.vue"),
              meta: {
                title: "GET count_metadata - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "update_metadata",
              name: "multicolorengine/update_metadata",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefUpdateMetadata.vue"),
              meta: {
                title: "POST update_metadata - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "get_metadata",
              name: "multicolorengine/get_metadata",
              component: () =>
                import("./views/multicolorengine/api_reference/methods/ApiRefGetMetadata.vue"),
              meta: {
                title: "GET get_metadata - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "get_search_metadata",
              name: "multicolorengine/get_search_metadata",
              component: () =>
                import(
                  "./views/multicolorengine/api_reference/methods/ApiRefGetSearchMetadata.vue"
                ),
              meta: {
                title:
                  "GET get_search_metadata - MulticolorEngine - TinEye developer documentation",
              },
            },
            {
              path: "get_return_metadata",
              name: "multicolorengine/get_return_metadata",
              component: () =>
                import(
                  "./views/multicolorengine/api_reference/methods/ApiRefGetReturnMetadata.vue"
                ),
              meta: {
                title:
                  "GET get_return_metadata - MulticolorEngine - TinEye developer documentation",
              },
            },
          ],
        },
        {
          path: "*",
          redirect: { name: "multicolorengine/what_is_multicolorengine" },
        },
      ],
    },
    {
      path: "/*",
      redirect: { name: "product_menu" },
    },
  ],
});

router.afterEach((to) => {
  document.title = to.meta.title || "TinEye Developer Documentation";
});

export default router;
